import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface NewAgentButtonProps {
  variant?:
    | 'default'
    | 'outline'
    | 'secondary'
    | 'ghost'
    | 'transparent'
    | 'gradient';
  className?: string;
}

const NewAgentButton: React.FC<NewAgentButtonProps> = ({
  variant = 'default',
  className = '',
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/agents/new');
  };

  return (
    <Button variant={variant} onClick={handleClick} className={className}>
      <Plus className="w-4 h-4 sm:w-4 sm:h-4" />
      <span className="text-base font-normal hidden sm:inline">
        {t('agent.list.new_agent_button.translation')}
      </span>
    </Button>
  );
};

export default NewAgentButton;
